// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterLinks__link":"ce_a bhi_h bhi_kf bhi_wb bhi_ss bhi_vr bhi_su bhi_sl"};